import React from 'react'

import {
  Box,
  Heading3,
  Display,
  AlignItems,
  Color,
  Space,
  FontWeight,
  FlexDirection,
  JustifyContent,
} from '@gousto-internal/citrus-react'

import { Cta, useGetCtaProps } from '../Cta'
import { AdvantagesList } from './AdvantagesList'
import { AdvantagesContainer, ValueForMoneyContainer } from './containers.styled'
import { title, valueForMoneytrackingSectionName } from './data'

export const ValueForMoney = () => {
  const { ctaUri, ctaText } = useGetCtaProps()

  return (
    <ValueForMoneyContainer
      height={[null, '711px']}
      paddingH={[null, 6, 8]}
      paddingV={[null, 10, 0]}
      paddingBottom={[null, 0]}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      justifyContent={[null, null, JustifyContent.Center]}
      alignItems={[null, null, AlignItems.Center]}
      data-testid={valueForMoneytrackingSectionName}
    >
      <Box width="100%" maxWidth="1071px">
        <AdvantagesContainer
          width={[null, '449px']}
          paddingH={8}
          paddingV={8}
          paddingRight={[8, 16]}
          paddingBottom={4}
        >
          <Heading3 color={Color.ColdGrey_900} fontWeight={FontWeight.Bold}>
            {title}
          </Heading3>
          <Space size={6} direction="vertical" />
          <AdvantagesList />
          <Space size={2} direction="vertical" />
          <Box>
            <Cta ctaUri={ctaUri} trackingSectionName={valueForMoneytrackingSectionName}>
              {ctaText}
            </Cta>
          </Box>
        </AdvantagesContainer>
      </Box>
      <Space size={[20, 0]} direction="vertical" />
      <Space size={[20, 0]} direction="vertical" />
      <Space size={[16, 0]} direction="vertical" />
    </ValueForMoneyContainer>
  )
}
